import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="font-[Outfit]">
      <div className="flex justify-between items-center py-4 xs:px-8 lg:px-12 shadow-sm">
        <div className="text-2xl font-bold">Reesume</div>
        <div className="flex justify-between items-center">
          <div
            className="text-md font-medium underline underline-offset-4 cursor-pointer"
            onClick={() => navigate("/login")}
          >
            Login
          </div>
          <div
            className="text-md font-medium rounded-full bg-dark-bg text-dark-fg px-4 py-2 ml-4 cursor-pointer"
            onClick={() => navigate("/signup")}
          >
            Signup
          </div>
        </div>
      </div>
      <div className="xs:pt-6 lg:pt-0 flex flex-col justify-between xs:px-8 lg:px-12 h-[calc(100vh-4.5rem)]">
        <div className="flex h-[calc(100vh-8rem)] flex-wrap xs:justify-between xs:items-center lg:justify-normal lg:items-normal">
          <div className="w-full lg:max-w-[50%]">
            <div className="text-[2rem] lg:text-[4rem] font-bold w-full leading-[1.2]">
              Create a Minimalistic and Impactful Resume in Minutes
            </div>
            <div className="text-[1.2rem] font-normal mt-4 leading-[2] w-full lg:max-w-[70%]">
              Choose from Two Elegant Themes:{" "}
              <span className="bg-dark-bg text-dark-fg rounded p-1">
                Charcoal
              </span>{" "}
              and{" "}
              <span className="bg-light-bg text-light-fg rounded p-1">
                Vanilla
              </span>
              , with Reesume.
            </div>
            <div
              className="w-full lg:w-fit text-[1.2rem] text-center text-md font-medium rounded-full bg-dark-bg text-dark-fg px-6 py-3 mt-8 lg:mt-5 shadow-md cursor-pointer"
              onClick={() => {
                navigate("/builder");
              }}
            >
              Build My Resume
            </div>
          </div>
          <div className="w-full lg:max-w-[50%] mt-[4rem]">
            <img
              className="w-full scale-[1.1] lg:scale-[1]"
              src="mockup.png"
              alt="mockup"
            />
          </div>
        </div>
        <div className="flex justify-between items-center flex-wrap py-4">
          <div className="text-xs lg:text-md font-normal text-center">
            © {new Date().getFullYear()} Reesume.
          </div>
          <a
            href="https://www.producthunt.com/posts/reesume?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-reesume"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=423488&theme=neutral"
              alt="Reesume - Create&#0032;a&#0032;minimalistic&#0032;and&#0032;impactful&#0032;resume&#0032;in&#0032;minutes | Product Hunt"
              className="w-[10rem]"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;
